var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audio-wrap"},[_c('g-audio',{ref:"gAudio",attrs:{"url":_vm.path},on:{"audioValueChange":_vm.eventHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }